import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  detailBody: {
    minHeight: '20vh',
    padding: '10px 0',
  },
  projectTitle: {
    fontSize: '1.4em',
    fontWeight: 400,
  },
  lineDivider: {
    width: '100%',
    borderBottom: '2px solid #747474',
    marginTop: 20
  },
  technologiesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 5,
    marginTop: 10,
  },
  technology: {
    padding: '2px 5px !important',
    borderRadius: '5px !important',
    fontSize: '.85em !important',
    fontWeight: 200,
    border: "2px solid #0A5FFF !important",
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  carouselBg: {
    background: 'rgba(21, 20, 20, 0.529)',
    height: '300px',
  },
  projectDescription: {
    marginTop: "10px",
  },
  actionBtn: {
    display: 'flex',
    width: '100%',
    gap: 10,
    "& .website": {
      backgroundColor: '#0954e3',
      padding: '2px 20px',
      fontSize: '1em',
      color: '#fff',
      borderRadius: 5,
      height: '40px',
      '&:hover': {
        transform: 'scale(1.05)'
      },
    },
    '& .github': {
      border: '1px solid #737373',
      backgroundColor: '#dadada',
      padding: '3px 20px',
      height: '40px',
      borderRadius: 3,
      '&:hover': {
        transform: 'scale(1.05)'
      },
    },
  },
  projectImgBox: {
    height: '250px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
    '& img': {
    height: '100%',
   // width: '100%',
    objectFit: 'cover',
    }
  },
  projectImag: {},
}))

export default  useStyles;
